import styled from "styled-components"

export const Wrapper = styled.div`
  width: 100%;
  flex: 1;
  background: var(--white);
  ß form {
    margin-bottom: 0;
  }
`
